module.exports = __webpack_public_path__ + "static/media/icon_mail.78db25a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/icon_mail.svg
// module id = 43
// module chunks = 0